import { createFileRoute } from "@tanstack/react-router";
import AdminDistributorEdit from "@/pages/admin/AdminDistributorEdit";

export const Route = createFileRoute("/_adminLayout/admin/parts/distributors/$id")({
  component: AdminDistributorEdit,
});
